import * as Scrivito from "scrivito";

export function getNewsCategories() {
  return Scrivito.load(() => {
    const [configObj] = Scrivito.Obj.onAllSites()
      .where("_objClass", "equals", "GlobalConfigPage")
      .take(1);

    if (!configObj) return [];

    const categoryConfigWidget = configObj
      .get("body")
      .find((item) => item.objClass() === "NewsCategoryConfigWidget");

    if (!categoryConfigWidget) return [];

    return categoryConfigWidget.get("body").map((item) => ({
      key: item.get("key"),
      de: item.get("de"),
      en: item.get("en"),
    }));
  });
}
